<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>상담 목록</p>
                <div class="area_button">
                    <!-- <button type="button" @click="window.alert('준비중입니다.')">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button>
                    <button type="button">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button> -->

                    <button type="button" @click="router.push({ name: 'clientDetail', params: { id: state.idx } })">
                        <span>기초 기록으로 연계</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <ClientDetail :idx="state.idx"></ClientDetail>
                </div>
            </div>
        </div>
    </section>
    <section class="container">
        <div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_button area_button_top">
                        <button type="button" @click="router.push({ name: 'counselAdd', params: { id: state.idx } })">
                            <span>새 상담기록 작성</span>
                        </button>

                        <div class="flex ac">
                            <label for="moveNumber" class="area_label_tit">이동연번</label>
                            <input type="text" id="moveNumber" v-model="state.moveNumber" placeholder="연번" />
                        </div>

                        <div class="flex ac">
                            <label for="moveNumber" class="area_label_tit">이동부서</label>
                            <div class="select-wrap">
                                <select v-model="state.moveDept">
                                    <option value="0">선택해주세요.</option>
                                    <option v-for="item in CommonOptions.deptListForMove" :value="item.name">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>

                            <button type="button" class="active" @click="move">
                                <span>이동</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_button area_button_top">
                        <button type="button" @click="showHistoryModal()">
                            <span>새 이력 작성</span>
                        </button>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.orderForHistory" @change="getHistoryList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageStateForHistory.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageStateForHistory.list"
                                :columns="pageStateForHistory.fields"
                                :totalLength="pageStateForHistory.length"
                                :perPage="pageStateForHistory.perPage"
                                :cntPage="pageStateForHistory.cntPage"
                                :current-page="pageStateForHistory.currentPage"
                                :isLoading="pageStateForHistory.isLoading"
                                @onRowClick="fnRowClickForHistory"
                                @onPaging="getHistoryList"
                                @onNextPage="fnGoPageForHistory"
                                @onPrevPage="fnGoPageForHistory"
                                @onFirstPage="fnGoPageForHistory"
                                @onLastPage="fnGoPageForHistory"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <HistoryDetail
        v-if="state.isShowHistoryModal"
        :idx="state.historyIdx"
        :clIdx="state.idx"
        @close="closeModal"
        @callback="callBackModalForHistory"
    ></HistoryDetail>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        apiService,
        router,
        Header,
        Left,
        ModalDefault,
        ClientDetail,
        HistoryDetail,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        useRoute,
        onActivated,
        watch,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, ClientDetail, HistoryDetail },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setDate(today.getDate() - 90);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "" as string,
                searchText1: "" as string,
                searchType2: "" as string,
                searchText2: "" as string,
                searchType3: "" as string,
                searchText3: "" as string,
                searchType4: "" as string,
                searchText4: "" as string,
                dept: 0 as number,
                order: 0 as number,
                isChild: 0 as number,

                orderForHistory: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowHistoryModal: false as boolean,

                idx: 0 as number,
                moveNumber: "" as string,
                moveDept: "" as string,

                historyIdx: 0 as number,
            });

            const searchCondition = [
                { key: "number", name: "연번" },
                { key: "name", name: "이름" },
                { key: "consultDepartment", name: "상담부서" },
                { key: "writer", name: "초기상담원" },
                { key: "counselor", name: "담당상담원" },
                { key: "state", name: "진행상황" },
                { key: "stateSub", name: "진행상황하위" },
                { key: "counselType", name: "상담유형" },
                { key: "phone", name: "연락처" },
            ];

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const stateSubList = [
                { key: "긴급", name: "긴급" },
                { key: "집중", name: "집중" },
                { key: "유지", name: "유지" },
                { key: "모니터링", name: "모니터링" },
            ];

            const fields = [
                { key: "", label: "No.", class: "text-center" },
                {
                    key: "date",
                    label: "작성일",
                    class: "text-center",
                    render: (row: any) => {
                        return CommonUtils.dateFormatYYYYMMDD(row.date, ".");
                    },
                },
                // {
                //     key: "vstNo",
                //     label: "연번",
                //     clickable: false,
                //     class: "text-left",
                // },
                // {
                //     key: "clientVO.name",
                //     label: "이름",
                //     clickable: false,
                //     class: "text-center",
                // },

                // {
                //     key: "clientVO.clientDetailVO.phone",
                //     label: "전화번호",
                //     clickable: false,
                //     class: "text-center",
                //     render: (row: any) => {
                //         return CommonUtils.convertPhoneNum(row.clientVO.clientDetailVO.phone);
                //     },
                // },

                // {
                //     key: "clientVO.clientDetailVO.birth",
                //     label: "생년월일",
                //     clickable: false,
                //     class: "text-center",
                //     render: (row: any) => {
                //         return CommonUtils.dateFormatYYYYMMDD(row.clientVO.clientDetailVO.birth, ".");
                //     },
                // },
                { key: "consultDepartment", label: "상담부서", class: "text-center" },
                { key: "title", label: "제목", class: "text-left maxWidth400", clickable: true },
                { key: "cstype", label: "상담유형", class: "text-center" },
                { key: "csmName", label: "작성자", class: "text-center" },
                {
                    key: "state",
                    label: "진행상황",
                    class: "text-center",
                    render: (row: any) => {
                        let strResult = "";
                        switch (row.clientState) {
                            case 0:
                                strResult = "데이터없음";
                                break;
                            case 1:
                                strResult = "진행";
                                break;
                            case 2:
                                strResult = "종결";
                                break;
                            case 3:
                                strResult = "보류";
                                break;
                            case 4:
                                strResult = "비해당";
                                break;
                        }
                        if (row.clientState === 1 && row.stateSub && row.stateSub !== "" && row.stateSub !== "-") {
                            strResult += ` (${row.stateSub})`;
                        }
                        return strResult;
                    },
                },
                // {
                //     key: "newSuccessState",
                //     label: "성과현황",
                //     class: "text-center",
                //     render: (row: any) => {
                //         let strResult = "";
                //         switch (row.newSuccessState) {
                //             case 0:
                //                 strResult = "없음";
                //                 break;
                //             case 1:
                //                 strResult = "있음";
                //                 break;
                //         }
                //         return strResult;
                //     },
                // },
                { key: "result", label: "조치결과", class: "text-center" },
                {
                    key: "state",
                    label: "승인 상태",
                    class: "text-center",
                    render: (row: any) => {
                        let strResult = "";
                        switch (row.state) {
                            case 0:
                                strResult = "대기";
                                break;
                            case 1:
                                strResult = "승인";
                                if (row.counselDetailVO && row.counselDetailVO.opinion) {
                                    strResult += `(O)`;
                                }
                                break;
                            case 2:
                                strResult = "보완 요청";
                                break;
                        }
                        return strResult;
                    },
                },
            ];

            if (user.userInfo.auth === 6) {
                fields.push({
                    key: "strStateModify",
                    label: "수정 권한 상태",
                    class: "text-center",
                });

                fields.push({
                    key: "strStateRemove",
                    label: "삭제 권한 상태",
                    class: "text-center",
                });
            }

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: fields,
            });

            const pageStateForHistory = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    {
                        key: "createDate",
                        label: "작성일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormatYYYYMMDD(new Date(row.createDate), ".");
                        },
                    },
                    {
                        key: "number",
                        label: "연번",
                        clickable: true,
                        class: "text-center",
                        render: (row: any) => {
                            return row.number;
                        },
                    },

                    {
                        key: "writer",
                        label: "작성자",
                        clickable: false,
                        class: "text-center",
                    },

                    {
                        key: "btnModal",
                        label: "상세",
                        clickable: true,
                        class: "text-center",
                        render: () => {
                            return "<img src = 'img/modify_icon.png' style = 'width:24px; height:auto;cursor:pointer'>";
                        },
                    },
                ],
            });

            onActivated(() => {
                initState();
                // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                // state.endDate = today.toLocaleDateString("sv-SE");
                if (state.idx !== Number(route.params.id)) {
                    pageState.currentPage = 1;
                    pageStateForHistory.currentPage = 1;
                    state.idx = Number(route.params.id);
                }
                fnGetList(pageState.currentPage);
                getHistoryList(pageStateForHistory.currentPage);
            });

            const initState = () => {
                state.isShowModal = false;
                state.modalTab = -1;
                state.modalTitle = "";
                state.modalContent = "";
                state.isShowHistoryModal = false;
                state.idx = 0;
                state.moveNumber = "";
                state.moveDept = "";
                state.historyIdx = 0;
                pageState.list = [];
                pageState.isLoading = false;
            };

            watch(
                () => route.params.id,
                () => {
                    state.idx = Number(route.params.id);

                    initState();
                    // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    // state.endDate = today.toLocaleDateString("sv-SE");
                    if (state.idx !== Number(route.params.id)) {
                        pageState.currentPage = 1;
                        pageStateForHistory.currentPage = 1;
                        state.idx = Number(route.params.id);
                    }
                    fnGetList(pageState.currentPage);
                    getHistoryList(pageStateForHistory.currentPage);
                },
            );

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.counsel.ReqCounselList = {
                    page: page,
                    size: pageState.perPage,
                    searchType1: state.searchType1,
                    searchText1: state.searchText1,
                    searchType2: state.searchType2,
                    searchText2: state.searchText2,
                    searchType3: state.searchType3,
                    searchText3: state.searchText3,
                    searchType4: state.searchType4,
                    searchText4: state.searchText4,
                    order: state.order,
                    dept: state.dept,
                    startDate: state.startDate,
                    endDate: state.endDate,
                    searchType: "",
                    searchText: "",
                };
                let res: types.ResPaging = await apiService.counsel.listForClient(state.idx, param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "title") {
                    if (row.consultDepartmentF !== user.userInfo.team && user.userInfo.auth < 8) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                    router.push({ name: "counselDetail", params: { id: state.idx, idx: row.coIdx } });
                }
            };

            const fnRowClickForHistory = (row: any, col: any) => {
                if (col.key === "btnModal") showHistoryModal(row.idx);
                else if (col.key === "number") router.push({ name: "counselListForClient", params: { id: row.targetIdx } });
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const fnGoPageForHistory = (page: number) => {
                pageStateForHistory.currentPage = page;
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.isShowHistoryModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    fnGetList(1);
                    state.isShowModal = false;
                }
            };

            const callBackModalForHistory = async (param: any) => {
                getHistoryList(1);
                state.isShowHistoryModal = false;
            };

            const move = async () => {
                const param: types.counsel.ReqCounselForMove = {
                    targetNumber: state.moveNumber,
                    targetTeam: state.moveDept,
                    idx: state.idx,
                };
                const res = await apiService.counsel.move(param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "이동 되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getHistoryList = async (page: number) => {
                pageStateForHistory.currentPage = page;
                pageStateForHistory.isLoading = true;

                const param: types.client.ReqClientHistoryList = {
                    page: page,
                    size: pageState.perPage,
                    order: state.orderForHistory,
                    startDate: state.startDate,
                    endDate: state.endDate,
                    searchType: "",
                    searchText: "",
                };

                const res = await apiService.client.listForHistory(state.idx, param);
                if (res.returnCode === 0) {
                    pageStateForHistory.list = res.list.data;
                    pageStateForHistory.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageStateForHistory.isLoading = false;
            };

            const showHistoryModal = (idx?: number) => {
                let data = null;
                if (idx) {
                    state.historyIdx = idx;
                } else {
                    state.historyIdx = 0;
                }

                state.isShowHistoryModal = true;
            };

            return {
                router,
                state,
                pageState,
                pageStateForHistory,

                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                searchCondition,
                stateList,
                stateSubList,
                CommonOptions,
                move,
                closeModal,
                callBackModal,
                callBackModalForHistory,
                window,

                getHistoryList,
                fnRowClickForHistory,
                fnGoPageForHistory,
                showHistoryModal,
            };
        },
    };
</script>
<style>
    #moveNumber {
        background: #f7f7f9;
        border: 0;
        height: 30px;
        font-size: 15px;
        width: 300px;
    }
    .container button.active {
        padding: 0 25px;
        height: 30px;
    }
    .container div.area_body div.area_button.area_button_top button {
        height: 30px;
        padding: 0 10px;
        font-size: 15px;
        color: #6d6d6d;
    }
    .container div.area_body div.area_button.area_button_top {
        gap: 20px;
    }
    .area_label_tit {
        font-weight: 500;
    }
</style>
